import React, { useState, useEffect } from "react";
import { PRICES as DEFAULT_PRICES } from "../data/content";
import axios from "axios";

const Pricing = ({ onCTAClick }) => {
  const [prices, setPrices] = useState(DEFAULT_PRICES);
  const [active, setActive] = useState(0);

  useEffect(() => {
    axios.get("/api/site/content")
      .then((res) => {
        if (res.data?.prices && Array.isArray(res.data.prices) && res.data.prices.length > 0) {
          setPrices(res.data.prices);
        }
      })
      .catch(() => {});
  }, []);

  const safeActive = Math.min(active, Math.max(0, prices.length - 1));
  const cat = prices[safeActive] || prices[0];

  return (
    <section id="prices" className="section-y bg-burgundy text-cream relative" data-testid="pricing-section">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <h2 className="font-heading text-5xl md:text-7xl text-cream heading-tight">
              Честно
              <br />
              <span className="accent text-gold-light">без сюрпризов.</span>
            </h2>
            <p className="mt-8 lede text-cream/85">
              Цены ориентировочные — окончательная стоимость зависит от состояния пары и материала. Точную сумму скажем после осмотра.
            </p>

            <div className="mt-10 space-y-2" role="tablist" aria-label="Категории прайса">
              {prices.map((c, i) => (
                <button
                  key={c.category}
                  role="tab"
                  aria-selected={i === safeActive}
                  onClick={() => setActive(i)}
                  className={`w-full text-left px-5 py-4 border-2 transition-all uppercase tracking-[0.18em] text-xs font-bold ${
                    i === safeActive
                      ? "bg-cream text-burgundy border-cream"
                      : "border-cream/40 text-cream/85 hover:border-cream"
                  }`}
                  data-testid={`pricing-tab-${i}`}
                >
                  {c.category}
                </button>
              ))}
            </div>

            <button onClick={onCTAClick} className="btn-ghost mt-12 !text-cream !border-cream hover:!bg-cream hover:!text-burgundy" data-testid="pricing-cta-quote">
              Рассчитать стоимость
            </button>
          </div>

          <div className="lg:col-span-8">
            <div className="border-2 border-cream/40 bg-burgundy-deep/50">
              <div className="px-6 md:px-10 py-6 border-b-2 border-cream/40 flex items-center justify-between">
                <h3 className="font-heading text-3xl md:text-4xl text-cream" data-testid="pricing-active-category">{cat?.category}</h3>
                <span className="font-heading text-gold-light text-4xl">{`0${safeActive + 1}`}</span>
              </div>
              <ul>
                {cat?.rows?.map((r, i) => (
                  <li
                    key={r.service}
                    className="flex items-baseline justify-between gap-6 px-6 md:px-10 py-5 border-b border-cream/20 last:border-b-0 hover:bg-burgundy-deep/70 transition-colors"
                    data-testid={`pricing-row-${safeActive}-${i}`}
                  >
                    <span className="text-cream text-base md:text-lg font-medium">{r.service}</span>
                    <span className="border-b border-dashed border-cream/40 flex-1 mx-3 mb-1.5" aria-hidden="true" />
                    <span className="font-heading text-cream text-2xl md:text-3xl whitespace-nowrap">{r.price}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
